












import { computed, defineComponent, ref, toRef, watch } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import { userWithAvatarFields } from "@/lib/fieldsHelper";
import { GRID_PAGE_SIZE } from "@/const";
import PurchaseGalleryView from "./components/PurchaseGalleryView";
import { filterItems } from "./const";

export default defineComponent({
  name: "PagePurchaseGallery",
  components: { PurchaseGalleryView },
  props: {
    providerId: { type: String, required: true },
    itemId: { type: String },
    type: { type: String, default: "all" },
  },
  setup(props) {
    const { authUserStrict } = useAuthUser();
    const loading = ref(false);
    const provider = ref<UserPublicData>();

    const filterData = computed(() => ({ subjectTypes: filterItems.find(i => i.name === props.type)?.value }));

    const { getFirstPage, getNextPage, items: purchasedItems, enableScroll, data } = usePager(page => {
      return providers.PurchasedItemsProvider.search({
        data: {
          consumerId: authUserStrict.value.id,
          providerId: props.providerId,
          page,
          size: GRID_PAGE_SIZE,
          sort: "PURCHASE_TIME,DESC",
          ...filterData.value,
        },
      });
    });

    const totalItems = computed(() => data.value?.totalRecords ?? 0);

    const getProvider = async () => {
      const response = await providers.UserPublicDataProvider.search(
        { data: { id: [props.providerId] } },
        userWithAvatarFields({ onlineStatus: true })
      );
      provider.value = response.result[0];
    };

    const getData = async () => {
      try {
        loading.value = true;
        await Promise.all([getFirstPage(), getProvider()]);
      } finally {
        loading.value = false;
      }
    };

    watch(toRef(props, "type"), getData, { immediate: true });

    return { enableScroll, loading, purchasedItems, provider, getNextPage, totalItems };
  },
});
